import React from "react";
import PropTypes from "prop-types";
import { withFormik, Field } from "formik";
import { useTranslation } from "react-i18next";
import {
  dataModel,
  validationDataModel,
  setInitialValues,
} from "./varietyForm.data.form";
import PATHS from "../../../../constants/paths";
import { useNavigate } from "react-router-dom";
import {
  InputText,
  InputSelect,
  InputCheck,
  BreadCrumb,
} from "@de-prado-dev/react-component-library";
import { CULTURES } from "../../../../constants/index";

const VarietyForm = (props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { handleSubmit, onback, edit } = props;
  const breads = [
    { label: t("home"), path: PATHS.HOME },
    { label: t("forms.variety.title"), path: PATHS.VARIETY_LIST },
    { label: t("forms.variety.titleNew") },
  ];

  return (
    <>
      <div className="row justify-content-center">
        <div className="col-12 col-md-11 marg-btm-1rem marg-top-40px">
          <h3 className="title">
            {edit ? t("forms.variety.titleEdit") : t("forms.variety.titleNew")}
          </h3>
        </div>
      </div>
      <BreadCrumb items={breads} />
      <div className="row justify-content-center  ">
        <div className="col-12 col-md-5">
          <form autoComplete="off" onSubmit={handleSubmit}>
            <div className="row">
              <div className="col-12">
                <Field
                  id="name"
                  className="form-control"
                  labelField={t("forms.variety.labels.name")}
                  name="name"
                  placeholder=""
                  component={InputText}
                  fieldType="text"
                  mandatory
                />
              </div>
            </div>
            <div className="row mt-2">
              <div className="col-12">
                {/* <Field
                  id="culture"
                  name="culture"
                  labelField={t("forms.variety.labels.culture")}
                  component={InputSelect}
                  placeholder=""
                  optionLabel="label"
                  optionValue="code"
                  options={CULTURES.map((item) => ({
                    ...item,
                    label: t(item.label),
                  }))}
                  addOptionEmpty
                  classNamePrefix="dark"
                  mandatory
                /> */}
                <Field
                  id="culture"
                  name="culture"
                  labelField={t("forms.variety.labels.culture")}
                  component={InputSelect}
                  placeholder=""
                  optionLabel="label"
                  optionValue="code"
                  options={CULTURES.map((item) => ({
                    ...item,
                    label: t(item.label),
                  }))}
                  classNamePrefix="dark"
                  mandatory
                  isMultiple
                />
              </div>
            </div>
            <div className="row mt-3">
              <div className="col-12">
                <Field
                  id="active"
                  labelField={t("forms.variety.labels.active")}
                  name="active"
                  placeholder=""
                  component={InputCheck}
                  mandatory
                />
              </div>
            </div>

            <div className="row justify-content-center">
              <div className="col-10 col-sm-11 text-center mt-5 mb-5">
                <button
                  type="button"
                  onClick={() => onback()}
                  className="btn btn-lg btn-primary me-2"
                >
                  {t("forms.variety.buttons.cancel")}
                </button>
                <button type="submit" className="btn btn-lg btn-secondary">
                  {t("forms.variety.buttons.save")}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

VarietyForm.propTypes = {
  handleSubmit: PropTypes.func,
  initialValues: PropTypes.object,
  onback: PropTypes.func,
  edit: PropTypes.bool,
};

const VarietyFormF = withFormik({
  mapPropsToValues: (props) => {
    if (props.initialValues) {
      return setInitialValues(props.initialValues);
    }
    return dataModel;
  },
  validationSchema: (props) => {
    return validationDataModel(props.edit);
  },
  handleSubmit: (values, { props, resetForm }) => {
    props.onSubmit(values, resetForm);
  },
  enableReinitialize: true,
  displayName: "VarietyForm",
})(VarietyForm);

export default VarietyFormF;
